import slide1_main from '@/app/[locale]/common/assets/images/slider-main/slide_1.webp';
import slide1_main_mob from '@/app/[locale]/common/assets/images/slider-main/slide1_mob.webp';
import slide2_main from '@/app/[locale]/common/assets/images/slider-main/slide_2.webp';
import slide2_main_mob from '@/app/[locale]/common/assets/images/slider-main/slide2_mob.webp';
import slide3_main from '@/app/[locale]/common/assets/images/slider-main/slide_3.webp';
import slide3_main_mob from '@/app/[locale]/common/assets/images/slider-main/slide3_mob.webp';
import slide4_main from '@/app/[locale]/common/assets/images/slider-main/slide_4.webp';
import slide4_main_mob from '@/app/[locale]/common/assets/images/slider-main/slide4_mob.webp';
import slide1_ind_webp from "@/app/[locale]/common/assets/images/industires/slide-1.webp";
import slide2_ind_webp from "@/app/[locale]/common/assets/images/industires/slide-2.webp";
import slide3_ind_webp from "@/app/[locale]/common/assets/images/industires/slide-3.webp";
import slide4_ind_webp from "@/app/[locale]/common/assets/images/industires/slide-4.webp";
import slide5_ind_webp from "@/app/[locale]/common/assets/images/industires/slide-5.webp";

export const SLIDER_TITLE_EN = {
    BEFORE: 'We Focus',
    HIGHLIGHT: 'On Your Fuel',
};

export const MAIN_SLIDER_CONTENT = [
    {
        image: slide1_main,
        mobImage: slide1_main_mob,
    },
    {
        image: slide2_main,
        mobImage: slide2_main_mob,
    },
    {
        image: slide3_main,
        mobImage: slide3_main_mob,
    },
    {
        image: slide4_main,
        mobImage: slide4_main_mob,
    }
];

export const INDUSTRIES_SLIDER_CONTENT = [
    {
        label: 'Marine Vessels',
        text: 'With extensive experience in marine equipment, we help vessel owners optimize fuel costs through advanced monitoring solutions tailored for maritime operations.',
        href: '/industries/marine-vessels',
        image: slide1_ind_webp,
    },
    {
        label: 'Construction',
        text: 'We install fuel level sensors and flow meters for construction equipment, integrating data with our online monitoring platform to provide real-time fuel usage insights and enhance efficiency.',
        href: '/industries/construction',
        image: slide2_ind_webp,
    },
    {
        label: 'Logistics',
        text: 'We support fleet owners in reducing fuel consumption by implementing fuel level sensors and telematics systems, combined with an online monitoring service for accurate tracking and analysis.',
        href: '/industries/logistics',
        image: slide3_ind_webp,
    },
    {
        label: 'Agriculture',
        text: 'Our solutions for the agricultural sector include installing fuel monitoring devices and telematics systems to help farmers optimize fuel use and improve management through online monitoring.',
        href: '/industries/agriculture',
        image: slide4_ind_webp,
    },
    {
        label: 'Diesel generators',
        text: 'Our Diesel Generators Monitoring solution integrates cutting-edge telematics technology to provide comprehensive, real-time oversight of your generator fleet. ',
        href: '/industries/diesel-generators',
        image: slide5_ind_webp,
    },
];

export const INDUSTRIES_SLIDER_CONTENT_PH = [
    {
        label: 'Mga Sasakyang Pandagat',
        text: 'Sa malawak na karanasan sa kagamitang pandagat, tinutulungan namin ang mga may-ari ng sasakyang-dagat na ma-optimize ang gastos sa gasolina gamit ang mga advanced na solusyon sa pagsubaybay na iniakma para sa mga operasyon sa dagat.',
        href: '/industries/marine-vessels',
        image: slide1_ind_webp,
    },
    {
        label: 'Konstruksyon',
        text: 'Nag-i-install kami ng mga fuel level sensor at flow meter para sa kagamitang pangkonstruksyon, isinasama ang data sa aming online monitoring platform upang magbigay ng real-time na impormasyon sa paggamit ng gasolina at mapahusay ang kahusayan.',
        href: '/industries/construction',
        image: slide2_ind_webp,
    },
    {
        label: 'Logistika',
        text: 'Sinusuportahan namin ang mga may-ari ng fleet sa pagbabawas ng pagkonsumo ng gasolina sa pamamagitan ng paglalagay ng mga fuel level sensor at telematics system, na sinamahan ng online monitoring service para sa tumpak na pagsubaybay at pagsusuri.',
        href: '/industries/logistics',
        image: slide3_ind_webp,
    },
    {
        label: 'Agrikultura',
        text: 'Ang aming mga solusyon para sa sektor ng agrikultura ay kinabibilangan ng pag-install ng mga fuel monitoring device at telematics system upang matulungan ang mga magsasaka sa pag-optimize ng paggamit ng gasolina at pagpapabuti ng pamamahala sa pamamagitan ng online monitoring.',
        href: '/industries/agriculture',
        image: slide4_ind_webp,
    },
    {
        label: 'Mga Diesel Generator',
        text: 'Ang aming solusyon sa Pagsubaybay ng Diesel Generator ay gumagamit ng makabagong teknolohiyang telematics upang magbigay ng komprehensibo at real-time na pangangasiwa sa iyong fleet ng generator.',
        href: '/industries/diesel-generators',
        image: slide5_ind_webp,
    },
];


export const MAIN_SLIDER_BREAKPOINT_RESPONSIVE_IMAGES = {
    BREAKPOINT: 375,
    DESKTOP_FLAG: 'desktop',
    MOBILE_FLAG: 'mobile',
};